import {
  Component,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  EventEmitter,
  Injector,
} from '@angular/core';

import { Column } from '@shared/models/column.model';

@Component({
  selector: 'app-mfa-device-table',
  templateUrl: './mfa-device-table.component.html',
  styleUrls: ['./mfa-device-table.component.scss'],
})
export class MfaDeviceTableComponent implements OnInit, OnChanges {
  @Input() devices = [];
  @Output('removeDevice') removeDeviceEvent = new EventEmitter();

  columns: Column[] = [
    {
      header: 'Device Type',
      key: 'factorType',
      class: ['col-md-3'],

      canSort: false,
    },
    {
      header: 'Contact',
      key: 'contact',
      class: ['col-md-3'],
      canSort: false,
    },
    {
      header: 'Status',
      key: 'status',
      class: ['col-md-4'],
      canSort: false,
    },
    {
      header: 'Actions',
      actions: [
        {
          name: 'Remove',
          onClick: device => this.removeDevice(device),
          class: ['link'],
        },
      ],
      class: ['col-md-2', 'text-end'],
      showHeader: false,
      canSort: false,
    },
  ];

  formName = 'multi-factor-device-table';

  constructor(public injector: Injector) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    for (const prop in changes) {
      this[prop] = changes[prop].currentValue;
    }
    this.setFactorTypes();
  }

  setFactorTypes() {
    this.devices = this.devices.map(device => {
      device.contact =
        device.profile?.phoneNumber || device.profile?.email || '';

      let factorType = '';
      switch (device.factorType) {
        case 'push':
          factorType = 'Okta Verify Push';
          break;
        case 'call':
          factorType = 'Voice';
          break;
        case 'sms':
          factorType = 'Text Message';
          break;
        case 'email':
          factorType = 'Email';
          break;
        case 'token:software:totp':
          if (device.provider === 'OKTA') {
            factorType = 'Okta Verify';
          } else if (device.provider === 'GOOGLE') {
            factorType = 'Google Authenticator';
          }
          break;
        default:
          factorType = device.factorType;
      }
      return { ...device, factorType };
    });
  }

  removeDevice(device) {
    this.removeDeviceEvent.emit(device);
  }
}
